/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createRandom } from '../../factoriesAny.js';
export var randomDependencies = {
  typedDependencies: typedDependencies,
  createRandom: createRandom
};